import React from "react";
import { Route } from "react-router-dom";

import { EmptyPage } from "../pages/EmptyPage";
import BemVindo from "../pages/BemVindo/";
import PerfilSeguranca from "../pages/perfilSeguranca";
import Usuario from "../pages/usuario";
import ManterObrigacao from "../pages/manterObrigacao";
import ManterAmparoLegal from "../pages/ManterAmparoLegal";
import ListaCertidao from "../pages/certidao";
import Certidao from "../pages/certidao/certidaoView";
import CertidoesLegadas from "../pages/ConsultarCertidoesLegadas";
import ManterTipoCertidao from "../pages/materTipoCertidao";
import CertidoesAtivas from "../pages/ConsultarCertidoesAtivas";
import CertidaoCompensacao from "../pages/CertidaoCompensacao";
import CertidaoQuitacao from "../pages/CertidaoQuitacao";
import ManterEmpresa from "../pages/ManterEmpresas";
import AuditoriaEmpresa from "../pages/Auditoria/Empresa";
import AuditoriaObrigacao from "../pages/Auditoria/Obrigacao";
import AuditoriaAmparoLegal from "../pages/Auditoria/AmparoLegal";
import TipoCertidao from "../pages/Auditoria/TipoCertidao";
import CadastroTipoAto from "../pages/cadastroTipoAto";
import ValidaCertidaoLegada from "../pages/Auditoria/ValidaCertidaoLegada"

const Router = () => {
  return (
    <>
      <Route path="/" exact component={BemVindo} />
      <Route path="/usuario" exact component={Usuario} />
      <Route path="/perfilSeguranca" exact component={PerfilSeguranca} />
      <Route path="/manterObrigacao" exact component={ManterObrigacao} />
      <Route path="/manterAmparoLegal" exact component={ManterAmparoLegal} />
      <Route path="/listaCertidao" exact component={ListaCertidao} />
      <Route path="/certidao/:id" exact component={Certidao} />
      <Route path="/certidao/compensacao/:idenCertidao" exact component={CertidaoCompensacao} />
      <Route path="/certidao/quitacao/:idenCertidao" exact component={CertidaoQuitacao} />
      <Route path="/certidoesLegadas" exact component={CertidoesLegadas} />
      <Route path="/certidoesAtivas" exact component={CertidoesAtivas} />
      <Route path="/manterTipoCertidao" exact component={ManterTipoCertidao} />
      <Route path="/EmptyPage" exact component={EmptyPage} />
      <Route path="/manterEmpresa" exact component={ManterEmpresa} />
      <Route path="/audit/empresa" exact component={AuditoriaEmpresa} />
      <Route path="/audit/obrigacao" exact component={AuditoriaObrigacao} />
      <Route path="/audit/amparoLegal" exact component={AuditoriaAmparoLegal} />
      <Route path="/audit/tipoCertidao" exact component={TipoCertidao} />
      <Route path="/audit/validaCertidaoLegada" exact component={ValidaCertidaoLegada} />
      <Route path="/cadastroTipoAto" exact component={CadastroTipoAto} />
    </>
  );
};
export default Router;
